export const clientAgreementSchema = {
    price_package_id: '{type:"selectData", rules:"required", storeNamespace: "pricepackages", objectNamespace: "A_pricepackage", itemText: "name"}',
    date_valid_from: '{type:"datePicker", rules:"required"}',
    date_valid_to: '{type:"datePicker", rules:"required"}'
}